import React, { useEffect, useState } from "react";

import {
  fetchBookingInvoices,
  fetchCommissionInvoices,
} from "services/dashboard.services";
import { FiltersDropdown, NoResultsSection } from "reusableComponents";
import { useTranslation } from "react-i18next";
import LoadingPage from "views/LoadingPage";
import { useSelector } from "react-redux";
import { eyeIcon } from "assets/icons";
import { useModal } from "context";
import { DownloadIcon } from "assets/icons/svgComponents";

import styles from "./styles.module.scss";
import { useNavigate } from "react-router";

const CommissionInvoices = () => {
  const { t } = useTranslation("global");
  const { openModal } = useModal();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.token);
  const [orderBy, setOrderBy] = useState("date"); // Default order by 'date'
  const [order, setOrder] = useState("desc");

  // Order options for the dropdown
  const orderByOptions = [
    { label: t("dashboard.invoices.date"), value: "date" },
    { label: t("dashboard.invoices.invoiceNumber"), value: "id" },
  ];


  useEffect(() => {
    const fetchInvoices = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchCommissionInvoices(token, order, orderBy); // Pass order and orderBy
        setInvoices(data.data || []); // Handle empty data gracefully
      } catch (err) {
        setError(err.message || t("dashboard.messages.fetchError"));
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();
  }, [token, order, orderBy, t]);

  if (error)
    return (
      <div className={styles.error}>
        <p>{error}</p>
      </div>
    );

  return (
    <div
      className={`${styles.bookingInvoicesPage} ${
        loading ? styles.loading : ""
      }`}
    >
      {" "}
      <h2 className={styles.title}>{t("dashboard.invoices.title")}</h2>
      <div className={styles.filters}>
        <FiltersDropdown
          label={t("dashboard.history.orderBy")}
          options={orderByOptions}
          selected={orderBy}
          onSelect={setOrderBy}
          placeholder={t("dashboard.bookings.sortByPlaceholder")}
        />
      </div>
      {invoices.length > 0 ? (
        <div className={styles.invoicesTable}>
          <div className={styles.tableHeader}>
            <h3 className={styles.tableHeaderTitle}>
              {t("dashboard.invoices.invoiceNumber")}
            </h3>
            <p className={styles.tableHeaderTitle}>
              {t("dashboard.invoices.date")}
            </p>
            <p className={styles.tableHeaderTitle}>
              {t("dashboard.invoices.totalVAT")}
            </p>

            <span></span>
          </div>
          {invoices.map((invoice) => (
            <div key={invoice.id} className={styles.tableItem}>
              <h3
                className={`${styles.tableItemText} ${styles.reservationNumber}`}
              >
                {invoice.id}
              </h3>
              <p className={`${styles.tableItemText} ${styles.invoiceDates}`}>
                {invoice.date}
              </p>

              <p className={`${styles.tableItemText} ${styles.invoiceAmount}`}>
                {invoice.total_fee}€
              </p>

              <button
                className={styles.eyeIcon}
                onClick={() => window.open(invoice.url, '_blank')}
                aria-label={`View message: ${invoice.subject}`}
              >
                <DownloadIcon
                  width={"24px"}
                  height={"24px"}
                  className={styles.downloadIcon}
                />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <NoResultsSection
          title={t("dashboard.invoices.noResultTitle")}
          text={t("dashboard.invoices.noResultText")}
        />
      )}
    </div>
  );
};

export default CommissionInvoices;
